if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        if (!event.currentTarget.dataset.value) return;

        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}

(() => {
  const languageOptions = [
    { code: 'nl', hreflang: 'nl', label: 'Nederlands' },
    { code: 'en', hreflang: 'en', label: 'English' },
    { code: 'de', hreflang: 'de-DE', label: 'Deutsch' },
    { code: 'pl', hreflang: 'pl-PL', label: 'Polski' },
  ];

  const iconCheckmark = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
      <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/>
    </svg>
  `;

  const iconCaret = `
    <svg class="icon icon-caret" viewBox="0 0 10 6">
      <path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/>
    </svg>
  `;

  function normalizedPath() {
    let path = window.location.pathname || '/';
    for (const prefix of ['/de-de', '/pl-pl', '/en']) {
      if (path === prefix) return '/';
      if (path.startsWith(`${prefix}/`)) return path.slice(prefix.length) || '/';
    }
    return path || '/';
  }

  function currentLanguageCode() {
    const path = window.location.pathname || '/';
    if (path === '/de-de' || path.startsWith('/de-de/')) return 'de';
    if (path === '/pl-pl' || path.startsWith('/pl-pl/')) return 'pl';
    if (path === '/en' || path.startsWith('/en/')) return 'en';
    return 'nl';
  }

  function languageUrl(code) {
    const basePath = normalizedPath();
    if (code === 'nl') return basePath;
    const prefix = code === 'de' ? '/de-de' : code === 'pl' ? '/pl-pl' : '/en';
    return basePath === '/' ? prefix : `${prefix}${basePath}`;
  }

  function languageListMarkup() {
    const currentCode = currentLanguageCode();
    return languageOptions
      .map((language) => {
        const isCurrent = language.code === currentCode;
        return `
          <li class="disclosure__item" tabindex="-1">
            <a
              class="link link--text disclosure__link caption-large focus-inset"
              href="${languageUrl(language.code)}"
              hreflang="${language.hreflang}"
              lang="${language.code}"
              ${isCurrent ? 'aria-current="true"' : ''}
            >
              <span ${isCurrent ? '' : 'class="visibility-hidden"'}>${iconCheckmark}</span>
              <span>${language.label}</span>
            </a>
          </li>
        `;
      })
      .join('');
  }

  function languageFormMarkup(position, hiddenHeadingClass = 'visually-hidden') {
    const current = languageOptions.find((language) => language.code === currentLanguageCode()) || languageOptions[0];
    return `
      <localization-form>
        <form method="post" action="/localization" id="${position}Form" accept-charset="UTF-8" class="localization-form" enctype="multipart/form-data">
          <input type="hidden" name="form_type" value="localization">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="_method" value="put">
          <input type="hidden" name="return_to" value="${window.location.pathname}">
          <div>
            <h2 class="${hiddenHeadingClass}" id="${position}Label">Language</h2>
            <div class="disclosure">
              <button
                type="button"
                class="disclosure__button localization-form__select localization-selector link link--text caption-large"
                aria-expanded="false"
                aria-controls="${position}List"
                aria-describedby="${position}Label"
              >
                <span>${current.label}</span>
                ${iconCaret}
              </button>
              <div class="disclosure__list-wrapper language-selector" hidden>
                <ul id="${position}List" role="list" class="disclosure__list list-unstyled">
                  ${languageListMarkup()}
                </ul>
              </div>
            </div>
            <input type="hidden" name="locale_code" value="${current.code}">
          </div>
        </form>
      </localization-form>
    `;
  }

  function replaceStaleLanguageLists() {
    document.querySelectorAll('[id*="Language"][id$="List"]').forEach((list) => {
      if (list.querySelector('a[href^="/de-de"], a[href^="/pl-pl"]')) return;
      list.innerHTML = languageListMarkup();
      const disclosure = list.closest('.disclosure');
      const buttonLabel = disclosure?.querySelector('.localization-form__select span');
      const current = languageOptions.find((language) => language.code === currentLanguageCode());
      if (buttonLabel && current) buttonLabel.textContent = current.label;
    });
  }

  function ensureHeaderLanguageSelector() {
    replaceStaleLanguageLists();

    const desktopWrapper = document.querySelector('.desktop-localization-wrapper');
    if (desktopWrapper && !desktopWrapper.querySelector('#HeaderLanguageForm')) {
      desktopWrapper.insertAdjacentHTML('beforeend', languageFormMarkup('HeaderLanguage'));
    }

    const mobileWrapper = document.querySelector('.menu-drawer__localization.header-localization');
    if (mobileWrapper && !mobileWrapper.querySelector('#HeaderLanguageMobileForm')) {
      mobileWrapper.insertAdjacentHTML('beforeend', languageFormMarkup('HeaderLanguageMobile'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureHeaderLanguageSelector, { once: true });
  } else {
    ensureHeaderLanguageSelector();
  }
})();
